<template>
    <v-list-item-avatar :color="avatarColor">
      <av-media v-show="mediaReady" class="mt-1"
        :media="audio.srcObject" type="frequ" :frequ-lnum="16" :line-width="0.5"
        :canv-width="32" :canv-height="32"
        line-color="white"
      ></av-media>
      <v-progress-circular v-if="ringing" indeterminate
        size="40" width="1" color="primary">
        <v-icon color="primary">mdi-phone-ring</v-icon>
      </v-progress-circular>
      <div v-else-if="call.isOnHold || call.isMuted">
        <v-icon dark>mdi-{{ statusIcon }}</v-icon>
      </div>
    </v-list-item-avatar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'active-call-state-icon',
  props: {
    call: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({ audio: 'sipua/audio' }),
    mediaReady: function () {
      return this.call.isOnCall && !!this.audio.srcObject
    },
    ringing: function () {
      return this.call.isSending || this.call.isReceiving
    },
    statusIcon: function () {
      if (this.call.isOnHold) {
        return 'pause'
      } else if (this.call.isMuted) {
        return 'microphone-off'
      } else {
        return 'help'
      }
    },
    avatarColor: function () {
      if (this.call.isOnHold) {
        return 'red'
      } else if (this.call.isMuted) {
        return 'orange lighten-2'
      } else if (this.call.isOnCall) {
        return 'green darken-1'
      } else {
        return 'grey lighten-3'
      }
    }
  }
}
</script>

<style scoped>
</style>
